import React, { useState } from 'react'
import "./write.css"
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';


const Write = () => {
  const [value, setValue] = useState('');
  console.log(value);
  return (
    <div className='writeAdd'>
      <div className="writeContent">
        <input type="text" placeholder='Title' />
        <div className="editorContainer">
          <ReactQuill className="editor" theme='snow' value={value} onChange={setValue}/>
        </div>
      </div>
      <div className="writeMenu">
        <div className="item">
          <h1>Publish</h1>
          <span>
            <b>Status:</b> Draft
          </span>
          <span>
            <b>Visibility:</b> Public
          </span>
          <input style={{display:"none"}} type="file" id="file" name=""/>
          <label className="file" htmlFor="file">Upload Image</label>
          <div className="ButtonsDiv">
            <button>Save as a draft</button>
            <button>Update</button>
          </div>
        </div>
        <div className="item">
          <h1>Category</h1>
         <div className="cat">
           <input type="radio" name="cat" value="ARTIFICAL INTELLIGENCE" id="ARTIFICAL_INTELLIGENCE"/>
           <label htmlFor='ARTIFICAL INTELLIGENCE'>Artifical Intelligence</label>
          </div>
         <div className="cat">
           <input type="radio" name="cat" value="APPS" id="APPS"/>
           <label htmlFor='APPS'>Apps</label>
         </div>
         <div className="cat">
           <input type="radio" name="cat" value="HARDWARE" id="HARDWRE"/>
           <label htmlFor='HARDWRE'>Hardware</label>
         </div>
         <div className="cat">
           <input type="radio" name="cat" value="PROGRAMMING" id="PROGRAMMING"/>
           <label htmlFor='PROGRAMMING'>Programming</label>
         </div>
        
        </div>
      </div>
    </div>
  )
}

export default Write